export default "__VITE_ASSET__DPkKnOdS__"